import {
	createPushStateNavigator,
	type PushStateNavigator,
} from '@atlassian/jira-servicedesk-common/src/navigation/push-state-navigator';

let navigatorPromise: Promise<PushStateNavigator>;
export const getPushStateNavigator = () => {
	if (!navigatorPromise) {
		navigatorPromise = createPushStateNavigator();
	}
	return navigatorPromise;
};
